//Include Both Helper File with needed methods

import { changePasswordService } from "../../../Services/AuthService";
import { userForgetPasswordError, userForgetPasswordSuccess } from "./reducer";

export const userForgetPassword = (user, history) => async (dispatch) => {
  try {
    let response;
    if (process.env.REACT_APP_DEFAULTAUTH === "user") {
      response = changePasswordService(user);
    }

    const data = await response;

    if (data) {
      dispatch(userForgetPasswordSuccess("Password Change Successfully"));
    }
  } catch (forgetError) {
    dispatch(userForgetPasswordError(forgetError));
  }
};
